import AccountDetailsPage from "components/pages/AccountDetailsPage";

export default function CaptureEStatementsAccountDetails(props) {
    return <AccountDetailsPage />
}